import styled from 'styled-components';

const TablePagingWrapper = styled.div`
    padding: 5px 0;
    background: #f8f9fa;
    overflow:auto;
    ul.pagination {
        justify-content: center;
        display: flex;
        margin-bottom:0;
    }
    ul.pagination a.page-link {
        border-radius: 0 !important;
    }
`;

export default TablePagingWrapper;